export default __webpack_public_path__ + "russell@2x.21c88c8e.jpg";